import React from 'react';
import { Selection, Pedido } from '../../../../types';
import { formatCurrency } from '../../../../../../../../../utils/functions';
import QuantitySelector from '../../../shared/QuantitySelector/QuantitySelector';
import ClientSelector from '../../../GeneralView/components/ClientSelector/ClientSelector';
import ItemInfo from '../../../shared/ItemInfo/ItemInfo';
import ActionButtons from '../../../shared/ActionButtons/ActionButtons';
import './ClientSelectionRow.scss';

interface ClientSelectionRowProps {
  selection: Selection & { pedido: Pedido };
  allowEdit: boolean;
  activeDropdownId: string | null;
  onIncreaseQuantity: (pedido_id: number, selection_id: string) => void;
  onDecreaseQuantity: (pedido_id: number, selection_id: string) => void;
  onDeleteSelection: (pedido_id: number, selection_id: string) => void;
  onSplitSelection?: (pedido_id: number, selection_id: string) => void;
  onToggleDropdown: (dropdownId: string, event: React.MouseEvent) => void;
  onSelectClient: (pedidoId: number, selectionId: string, clientIndex: number) => void;
  numPeople: number;
  formatClientLabel?: (clientIndex: number) => string;
}

const ClientSelectionRow: React.FC<ClientSelectionRowProps> = ({
  selection,
  allowEdit,
  activeDropdownId,
  onIncreaseQuantity,
  onDecreaseQuantity,
  onDeleteSelection,
  onSplitSelection,
  onToggleDropdown,
  onSelectClient,
  numPeople,
  formatClientLabel
}) => {
  const { pedido_id } = selection.pedido;
  const isPayed = selection.payed === true;

  return (
    <tr className={`selection-row ${isPayed ? 'payed-selection' : ''}`}>
      {/* Quantity Column */}
      <td className="quantity-column">
        <QuantitySelector
          quantity={selection.quantity}
          allowEdit={allowEdit}
          itemName={selection.item_name}
          onIncrease={() => onIncreaseQuantity(pedido_id, selection.selection_id)}
          onDecrease={() => onDecreaseQuantity(pedido_id, selection.selection_id)}
          isGranel={selection.is_granel}
          unitAcronym={selection.unit_acronym}
        />
      </td>
      {/* Client Column - always show selector to allow assignment */}
      <td className="client-column">
        <ClientSelector
          clientIndex={selection.clientIndex}
          dropdownId={`${pedido_id}-${selection.selection_id}`}
          activeDropdownId={activeDropdownId}
          onToggleDropdown={onToggleDropdown}
          onSelectClient={(clientIndex) => onSelectClient(pedido_id, selection.selection_id, clientIndex)}
          numPeople={numPeople}
          formatClientLabel={formatClientLabel}
        />
      </td>
      {/* Item Column (will receive inline price parentheses on mobile via CSS pseudo element or injected span) */}
      <td className="item-column">
        <ItemInfo selection={selection} priceForMobile={formatCurrency(selection.total_price)} />
      </td>

      {/* Actions Column */}
      <td className="actions-column">
        <ActionButtons
          quantity={selection.quantity}
          onSplit={() => onSplitSelection?.(pedido_id, selection.selection_id)}
          onDelete={() => onDeleteSelection(pedido_id, selection.selection_id)}
          allowEdit={allowEdit}
        />
      </td>
    </tr>
  );
};

export default ClientSelectionRow;
